import { Component, Input, OnInit, OnDestroy } from "@angular/core";
//import { MenuItem } from './menu-item.component';

@Component({
  selector: "wego-sidebar",
  template: `
            <aside class="main-sidebar">
              <section class="sidebar">
                <ul class="sidebar-menu text-capitalize">
                  <li class="menu-item cursor-pointer" *ngFor="let menuItem of menu" [data]="menuItem">
                  </li>
                </ul>
              </section>
              <!-- <wego-popup-lodder [isLoading]="isLoading"></wego-popup-lodder> -->
            </aside>
            `
  //directives: [MenuItem]
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input("menu") menu: string;
  // @Input("IsLoading") isLoading: string;

  constructor() {}

  ngOnInit() {}
  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/components/sidebar.component.ts